import { useGetProjectInstallationsQuery } from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  name: string;
  displayName: string;
}

export function useQuery(projectId: string) {
  const tuple = useGetProjectInstallationsQuery({
    variables: {
      projectId: projectId
    },
    skip: projectId === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.project?.installations.map((node) => ({
        id: node.id,
        name: node.id,
        displayName: `${node.area.displayName} ${node.subArea.displayName} ${node.installationType.displayName}`
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
